// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"39d06a5a","189":"2f8a747b","258":"907b4460","372":"13017ea5","488":"b3e981f9","627":"46a063c2","762":"ba79e65e","929":"2c9a71c5","933":"e8272905"}[chunkId] + ".chunk.js";
};